import ShoePreview from "./ShoePreview.component";

export default ShoePreview;
